import { types, flow, getParent } from 'mobx-state-tree';
import { toast } from '@myplay/ui';
import { user } from "@myplay/all";

import I18N from '../../I18N';
import { toTitleCase } from '../../utils/stringManipulations';
import { OPERATOR } from '../../utils/constants';

// const authModule = user.auth;
const teamsModule = user.teams;
const settingsModule = user.settings;

const Team = types
  .model('Team', {
    _id: types.maybeNull(types.string), 
    category: types.maybeNull(types.string),
    year: types.maybeNull(types.number),
    name: types.maybeNull(types.string),
    playersCount: types.maybeNull(types.number),
    videosCount: types.maybeNull(types.number), 
    highlightsCount: types.maybeNull(types.number) 
  })

const Coach = types
  .model('Coach', {
    _id: types.maybeNull(types.string),
    fullName: types.maybeNull(types.string),
    avatar: types.maybeNull(types.string),
    avatarBgColor: types.maybeNull(types.string),
    firstName: types.maybeNull(types.string),
    lastName: types.maybeNull(types.string),
    accountType: types.maybeNull(types.string),
    teams: types.maybeNull(types.array(Team))
  })
  .actions(self => ({
    setTeams(teams) {
      self.teams = [...teams];
    }, 
    setAccountType(accountType) {
      self.accountType = accountType;
    }
  }))
  ;

const CoachesStore = types
  .model('CoachesStore', {
    coaches: types.array(Coach)
  })
  .actions(self => ({
    setCoachesFromClub(club) {

      let newCoaches = [];
      club.teams.map(team => {
        const { members: { coaches, operators } } = team;
        const coachesAndOperators = [...operators, ...coaches];
        coachesAndOperators.map(coach => {
          const currentCoachIndex = newCoaches.findIndex(currentCoach => currentCoach._id === coach._id);
          if (currentCoachIndex === -1) {
            const coachCopy = {
              ...coach,
              teams: [{ 
                ...team, 
                category: team.category.name, 
                playersCount: team.members.players.length 
              }]
            }
            newCoaches.push(coachCopy);
          } else {
              newCoaches[currentCoachIndex].teams.push({ 
              ...team, 
              category: team.category.name, 
              playersCount: team.members.players.length 
            });
          }
        })
      });
      self.coaches = [...newCoaches];
    },
    removeTeamFromCoach: flow(function* removeTeamFromCoach(coach, team) {
      try {
        yield teamsModule.removeUserFromTeam(coach._id, team._id);
        const currentCoachIndex = self.coaches.findIndex(currentCoach => currentCoach._id === coach._id);
        const teamsCopy = coach.teams.filter(currentTeam => currentTeam._id !== team._id )
        self.coaches[currentCoachIndex].setTeams(teamsCopy);
        toast.success(toTitleCase(I18N.t("COACH_REMOVED_SUCCESSFULLY")));
      } catch (error) {
        toast.error(toTitleCase(I18N.t("SOMETHING_WENT_WRONG")));
        console.log(error);
      }
    }),
    attachCoachToTeam: flow(function* attachCoachToTeam(coach, team){
      try {
        const isCoachPartOfTeam = coach.teams.filter(currentTeam => currentTeam._id === team._id).length > 0;
        const currentCoachIndex = self.coaches.findIndex(currentCoach => currentCoach._id === coach._id);

        if (isCoachPartOfTeam) {
          toast.error(toTitleCase(I18N.t("COACH_ALREADY_IN_TEAM")));
          return;
        };
        
        yield teamsModule.attachUsersToTeam(team._id, [coach._id]);

        const teamsCopy = [...coach.teams, {
          ...team,  
          category: team.category.name, 
          playersCount: team.members.players.length 
        }];
        self.coaches[currentCoachIndex].setTeams(teamsCopy);

      } catch (error) {
        toast.error(toTitleCase(I18N.t("SOMETHING_WENT_WRONG")));
        console.log(error);
      }
    }), 
    getNotRelatedCoaches() {
      const { TeamsStore: { selectedTeam: { members: { coaches, operators } } } } = getParent(self);
      const coachesAndOperators = [...operators, ...coaches];
      const coachesToUpdate = self.coaches.filter(coach => coachesAndOperators.findIndex(currentCoach => currentCoach._id === coach._id) === -1);
      return coachesToUpdate;
    }, 
    getCoachById(coachId) {
      return self.coaches.filter(coach => coach._id === coachId)[0];
    }, 
    changeAccoutType: flow(function* changeAccoutType(user){
      try {
        yield settingsModule.changeToOperator(user._id);
        const coachIndex = self.coaches.findIndex(coach => coach._id === user._id);
        self.coaches[coachIndex].setAccountType(OPERATOR);
        toast.success(`${user.fullName} ${I18N.t("IS_NOW_OPERATOR")}`)
      } catch (error) {
        toast.error(toTitleCase(I18N.t("SOMETHING_WENT_WRONG")))
        console.log(error);
      }
    })
  }));

export default CoachesStore;